import daggy from 'daggy';

const AuthState = daggy.taggedSum('AuthState', {
  UnAuthenticated: [],
  AuthenticationFailed: [],
  Authenticated: [],
});

export default AuthState;
